import React from "react";
import Skeleton from "@mui/material/Skeleton";
import { Card } from "react-bootstrap";

const CalendarSkeleton = () => {
  return (
    <Card className="pb-3">
      <Card.Header className="pt-2">
        <Skeleton variant="text" width={200} height={40} className="mb-2" />
      </Card.Header>

      <Card.Body>
        <div className="d-flex flex-column gap-3">
          {[...Array(6)].map((_, rowIndex) => (
            <div key={rowIndex} className="d-flex gap-3">
              {[...Array(7)].map((_, colIndex) => (
                <Skeleton
                  key={rowIndex * 7 + colIndex}
                  variant="rectangular"
                  width={"100%"}
                  height={80}
                  className="p-2 border"
                />
              ))}
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default CalendarSkeleton;
